import { Tooltip, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { JSX } from 'react';

interface IUndoEdit {
  ['data-selector']?: string;
  onUndo?: () => void;
  id?: string;
  size?: 'sm' | 'md' | 'lg';
}

const UndoEdit = (props: IUndoEdit): JSX.Element => {
  const { id, onUndo, size } = props;
  const dataSelector = props['data-selector'] || `${id}-undo`;

  const undoLabel = 'Undo edit';

  return (
    <Tooltip hasArrow label={undoLabel} placement="top">
      <IconButton
        aria-label={undoLabel}
        size={size || 'lg'}
        data-selector={dataSelector}
        onClick={onUndo}
        icon={<FontAwesomeIcon icon={faArrowRotateLeft} />}
      />
    </Tooltip>
  );
};

export { UndoEdit };
